export default "__VITE_ASSET__Dcqh7r$U__"